import { DateField, ReferenceField, RichTextField, Show, SimpleShowLayout, TextField } from 'react-admin';

export const ClientNoteShow: React.FC = () => {
  return (
    <Show>
      <SimpleShowLayout>
        <TextField label="ID" source="id" />
        <ReferenceField label="Klient" link="show" reference="Client" source="client.id">
          <TextField source="user.email" />
        </ReferenceField>
        <RichTextField label="Poznámka" source="text" />
        <DateField label="Dátum vytvorenia" locales="sk" showTime={true} source="creationTimestamp" />
        <DateField label="Dátum aktualizie" locales="sk" showTime={true} source="updateTimestamp" />
      </SimpleShowLayout>
    </Show>
  );
};
